import { Component, Prop, Element, Host, h } from '@stencil/core';
import FieldDecorator from '../_interfaces/FieldDecorator';
import warn from '../../../../capabilities/warn';

/**
 * @description form-kit: Applies Design System styles to a slotted checkbox field.
 * @use
 * @formkit
 * @since 6.0.0
 * @slot - `default slot`: used to insert and display a checkbox input
 */
@Component({
  tag: 'hp6-checkbox-decorator',
  styleUrl: 'checkbox-decorator.scss',
  shadow: true,
})
export class CheckboxDecorator implements FieldDecorator {
  /**
   * Represents the validity status of the decorated input. Undefined indicates the user has not yet accessed it.
   */
  @Prop({ reflect: true }) isValid: boolean = undefined;

  @Element() host: HTMLElement;

  /**
   * getter for the decoratored <input /> element
   */
  get decoratedEl(): HTMLInputElement {
    const el = this.host.querySelector('input[type="checkbox"]') as HTMLInputElement;
    return el;
  }

  componentDidRender() {
    this.decorate();
  }

  decorate() {
    const { decoratedEl } = this;

    if (!decoratedEl) {
      return;
    }

    const hasId = decoratedEl.getAttribute('id');
    if (!hasId) {
      warn(
        'checkbox-decorator: input does not have an id attribute. This is required to associate the label with the input.',
      );
    }
  }

  render() {
    const { isValid } = this;

    const isValidated = isValid !== undefined;
    const validClass = isValid === true ? 'valid' : 'invalid';

    return (
      <Host data-decorator="checkbox" class={isValidated ? validClass : ''}>
        <div class="checkbox-wrapper">
          <slot />
          {isValidated && (
            <hp6-icon
              class="validation-icon"
              name={isValid === true ? 'system-success' : 'system-error'}
            />
          )}
        </div>
      </Host>
    );
  }
}
